const translations = {
    addBoundary: 'Add boundary',
    addressChangeBoundaryWarning:
        'Changing the address will remove the site boundary, you will need to recreate it.',
    archive: 'Archive',
    archiveConfirm: 'Are you sure you want to archive this site?',
    archiveTitle: 'Archive site',
    cancel: 'Cancel',
    createSite: 'New',
    doneBoundary: 'Done',
    drawBoundaryPrompt: 'Next, draw the site boundary on the map.',
    edit: 'Edit',
    editBoundary: 'Edit boundary',
    emptyState: 'No sites yet. Click New to add one.',
    loading: 'Loading…',
    save: 'Save',
    saveFailed: 'Failed to save site',
    searchPlaceholder: 'Search sites…',
    title: 'Sites'
};

export default translations;
